import { DocumentChangeInterface, OperationTypeEnum } from "@finway-group/shared/lib/models"
import { fetchAllActivities } from "Shared/store/actions/activity/activityActions"
import { refreshAuthUser } from "Shared/store/actions/auth/authActions"
import { fetchAllCompanies } from "Shared/store/actions/company/companyActions"
import { fetchAllEmployees, syncEmployee } from "Shared/store/actions/employee/employeeActions"
import { refetchUserRelatedTables } from "Shared/store/actions/tables/tableActions"
import AuthService from "../auth.service"

const updatedDependencies = async (dispatch: any) => {
    await AuthService.silentRefresh()
    await dispatch(refreshAuthUser())
    await dispatch(fetchAllActivities())
}

const subscribeToEmployee = async (dispatch: any, data: DocumentChangeInterface, loggedInUserId: string) => {
    const {
        fullDocument: { documentId, operationType },
    } = data

    if (operationType === OperationTypeEnum.INSERT || operationType === OperationTypeEnum.UPDATE || operationType === OperationTypeEnum.UPDATE_PROFILE_IMG) {
        if (operationType === OperationTypeEnum.UPDATE && documentId === loggedInUserId) {
            await updatedDependencies(dispatch)
        }

        await dispatch(syncEmployee(documentId.toString()))
        dispatch(refetchUserRelatedTables())
        await dispatch(fetchAllCompanies(false))
    }

    if (operationType === OperationTypeEnum.DELETE) {
        await updatedDependencies(dispatch)
        await dispatch(syncEmployee(documentId.toString()))
        dispatch(refetchUserRelatedTables())
        await dispatch(fetchAllCompanies(false))
    }

    if (operationType === OperationTypeEnum.BULK_UPDATE) {
        await dispatch(fetchAllEmployees())
        dispatch(refetchUserRelatedTables())
    }
}

export default subscribeToEmployee
